// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7d6b3ede","703":"79072c04","787":"6403002f"}[chunkId] + ".chunk.js";
};